module.exports = __webpack_public_path__ + "media/media/values/klim-kiforenko-91766d90399e1d147fad9ea62cf902e4.jpg";